export default __webpack_public_path__ + "static/media/resultado11-12-13.cd61b3d4.pdf";